module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/x-circle-9994c77bfd78d895eb727f485f771597.svg";